// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
      	filterTreeMobileStyle: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true,
      	//enableAjaxCart: window.innerWidth <= 768 ? false : true,
        enableAjaxCart: true,
	}
};

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
        var label = '';
        if (data.tags.includes('Lowest Price Ever')) {
          label = '<div class="product-tag-new">Lowest Price Ever</div>';
        } else if (data.tags.includes('New')) {
          label = '<div class="product-tag-new">New</div>';
        }
      	//var newLabel = data.tags.includes('New') ? '<div class="product-tag-new ">New</div>' : '';
      	var limitedtitmeofferLabel = data.tags.includes('Limited time offer') ? '<div class="product-tag-new right-product-tag-new">Limited Time Sale</div>' : '';
      	var limitedstock = data.tags.includes('Limited stock') ? '<div class="product-tag-new right-product-tag-new">Limited stock</div>' : '';
		var preOrder = data.tags.includes('Pre-Order Now') ? '<div class="product-tag-preorder">Pre Order</div>': '';
        itemHtml = itemHtml.replace(/{{preOrder}}/g, preOrder);
        itemHtml = itemHtml.replace(/{{newLabel}}/g, label);
		itemHtml = itemHtml.replace(/{{limitedtitmeofferLabel}}/g, limitedtitmeofferLabel);
		itemHtml = itemHtml.replace(/{{limitedstock}}/g, limitedstock);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
		itemImagesHtml += '<div style="padding-top:';
		if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
			itemImagesHtml += 1 / aspect_ratio * 100;
		} else {
			itemImagesHtml += 100;
		}
		itemImagesHtml += '%;">';
		itemImagesHtml += '<img id="' + imgId + '" ' +
          	'class="custom_alt_{{itemId}} grid-view-item__image lazyload" ' +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
		itemImagesHtml += '</div>';
      
        itemImagesHtml += '{{cashbackLabel}}'
        itemImagesHtml += '{{warrantyLabel}}'
        itemImagesHtml += '{{preOderLabel}}'
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
      
        var cashbackLabelHtml = "";
        var warrantyLabelHtml = "";
      	var preOderLabelHtml = "";
     //  var  reg = /Rs_[0-9]+_cashback/g;
    //console.log(tag);
        data.tags.forEach(function(tag){
          tag=tag.toLowerCase();
                   if(tag.includes("_cashback")){
                   
           var percentage = tag.replaceAll("_" , " ");
           var percentage = percentage.replace("cashback" , " Cashback*");
           var percentage=percentage.replace("Rs" , "&#x20B9");
         
            cashbackLabelHtml = '<div class="product-tag-percentage">'+ percentage  +'</div>'
          } 

          
          else if(tag.includes("Portable Wireless Speakers") && data.tags.includes("With Sony Mic")){
            cashbackLabelHtml = '<div class="product-tag-percentage">With Sony Mic</div>'
          }
          if(tag.includes("years_warranty")){
            var years = tag.replace("years_warranty" , "")
            warrantyLabelHtml = '<div class="product-tag-warranty">'+ years +' Years Warranty*</div>'
          }
          if(tag.includes("Pre-Order Now")){
            var preOder = tag.replace("Pre-Order" , "")
            preOderLabelHtml = '<div class="product-tag-preorder">Pre Order</div>'
          }
        })
        itemHtml = itemHtml.replace(/{{cashbackLabel}}/g, cashbackLabelHtml);
        itemHtml = itemHtml.replace(/{{warrantyLabel}}/g, warrantyLabelHtml);
      	itemHtml = itemHtml.replace(/{{preOderLabel}}/g, preOderLabelHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

      	var preBookLabelHtml = '';
      	if(data.tags.includes('Pre-book Now') || data.tags.includes('Pre-Book Now')){
           preBookLabelHtml += '<div class="boost-pfs-prebook">Pre Book</div>';
        }
      	itemHtml = itemHtml.replace(/{{preBookLabel}}/g, preBookLabelHtml);
            	
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if(typeof Utils.compileShopifyProductVariables == 'function'){
          itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
        	itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

      	var newLabel = data.tags.includes('New') ? '<div class="product-tag-new ">New</div>' : '';
      	var limitedtitmeofferLabel = data.tags.includes('Limited time offer') ? '<div class="product-tag-new right-product-tag-new">Limited Time Sale</div>' : '';
		var limitedstock = data.tags.includes('Limited stock') ? '<div class="product-tag-new">Limited stock</div>' : '';		  
		itemHtml = itemHtml.replace(/{{newLabel}}/g, newLabel);
		itemHtml = itemHtml.replace(/{{limitedtitmeofferLabel}}/g, limitedtitmeofferLabel);
		itemHtml = itemHtml.replace(/{{limitedstock}}/g, limitedstock);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if(typeof Utils.compileShopifyProductVariables == 'function'){
          itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
        	itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }

		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '';
          var meta_category="";
        var meta_subcategory="";
      console.log(data);
      var sku=data.skus[0];
			onSaleClass = onSale ? ' price--on-sale' : '';
		var soldOutClass = data.available ? '' : ' price--sold-out';
       if(data.metafields[1])
      {
          meta_category=data.metafields[1].value;
      }
        if(data.metafields[2])
      {
       meta_subcategory=data.metafields[2].value;
      } 
       
		var comparePriceVaries = data.compare_at_price_min != data.compare_at_price_max;
		var priceVariesClass = !priceVaries && comparePriceVaries ? ' price--compare-price-hidden' : '';
			variant = data.variants[0];
			unitPriceMeasurementClass = '';
			unitPriceSeparatorHtml = '';
			unitPirceBaseUnitHtml = '';
          priceHtml += '<input type="hidden" class="category" name="properties[category1][]" value="'+ meta_subcategory + '">';
          priceHtml += '<input type="hidden" class="subcategory" name="properties[category2][]" value="'+ meta_category + '">';
          priceHtml += '<input type="hidden" class="sku" name="sku" value="'+sku+ '">';
    
		if (variant.hasOwnProperty('unit_price_measurement')) {
			unitPriceMeasurementClass = ' price--unit-available';
		}

		priceHtml += '<div class="price price--listing' + onSaleClass + soldOutClass + priceVariesClass + unitPriceMeasurementClass + '" data-price>';
		if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
			priceHtml += '<div class="price__vendor price__vendor--listing"><dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt><dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd></div>';
		}

		
		
		priceHtml += '<div class="price__sale"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.sale_price +
			'</span></dt>';
		priceHtml += '<dd> <span class="price-item price-item--sale">';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min, undefined, true));
		} else {
			priceHtml += Utils.formatMoney(data.price_min, undefined, true);
		}
		priceHtml += '</span></dd>';
        if(onSale) {
          priceHtml += '<div class="price__compare"> <dt> <span class="visually-hidden visually-hidden--inline">';
          priceHtml += boostPFSConfig.label.regular_price;
          priceHtml += '</span></dt>';
          priceHtml += '<dd> <s class="price-item price-item--regular">';
          priceHtml += Utils.formatMoney(data.compare_at_price_min, undefined, true);
          priceHtml += '</s></div>';
          priceHtml += '</div>';
        }

		
        if(onSale){
          var reduction = data.compare_at_price_min - data.price_min;
          var percentage = Math.round(reduction/data.compare_at_price_min*100)
          priceHtml += '<p class="saving-price">You Save: <b>'+ Utils.formatMoney(reduction, undefined, true) + ' (' + percentage +'%)</b></p>';
        }
		priceHtml += '<div class="price__unit"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.unit_price_label;
		priceHtml += '</span></dt>';
		priceHtml += '<dd class="price-unit-price">';

		unitPriceSeparatorHtml += '<span aria-hidden="true">/</span><span class="visually-hidden">';
		unitPriceSeparatorHtml += boostPFSConfig.label.unit_price_separator + '&nbsp;</span>';

		if (variant.hasOwnProperty('unit_price_measurement') && variant.unit_price_measurement) {
			unitPirceBaseUnitHtml += '<span>';
			if (variant.hasOwnProperty('reference_value') && variant.unit_price_measurement.reference_value != 1) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_value;
			}
			if (variant.hasOwnProperty('reference_unit')) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_unit;
			}
			unitPirceBaseUnitHtml += '</span>';
		}

		if (variant.hasOwnProperty('unit_price')) {
			priceHtml += '<span>' + Utils.formatMoney(variant.unit_price, undefined, true) + '</span>';
		}

		priceHtml += unitPriceSeparatorHtml + unitPirceBaseUnitHtml;
		priceHtml += '</dd></div>';


		priceHtml += '</div>';
      
        if(!onSale){
          
           priceHtml += '<div class="price__regular">'
          priceHtml += '<p class="price-item price-item--regular">';
          priceHtml += Utils.formatMoney(data.price_min, undefined, true);
          priceHtml += '</p>'
          priceHtml += '</div>'
        }

		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '<option value="manual" diabled default hidden>Featured</option>';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
                 if(jQ('#boost-pfs-filter-top-sorting-select').val() == null) {
           jQ('#boost-pfs-filter-top-sorting-select').val('0')
         }
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
      
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
        this.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
          results.forEach(function(result){
            // Append the custom html to product item
            if(jQ('[data-id="'+ result.id+ '"].grid__item .product-form__controls-group').length === 0) {
              jQ(result.custom_html).insertAfter('[data-id="'+ result.id+ '"].grid__item .price--listing');
              setTimeout(function(){
                jQ('body .change_grid label img').on('click', function(){
                  var pro_id = '.custom_alt_'+jQ(this).attr('pro_id'),acrive_l = ".prod_id_"+jQ(this).attr('pro_id');
                  jQ(pro_id).attr('srcset',jQ(this).attr('img_change'));
                  jQ(acrive_l).removeClass('active_cus');
                  jQ(this).parent('label').addClass('active_cus').siblings();
                });
              }, 500)
            }
          })
        })
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
      
      	jQ('.boost-pfs-filter-options-wrapper')
        
          var item_per_row = 3;
        if(jQ(window).width() < 768) {
          item_per_row = 2;
        }
      
      adjustProductHeight(data.products, item_per_row)

	};
  
    function adjustProductHeight(data, item_per_row) {
      var list = data.reduce(function(result, value, index, array) {
        if (index % item_per_row == 0)
          result.push(array.slice(index, index + item_per_row).map(({id}) => id));
        return result;

      }, []);
      list.forEach(l => {
        var maxHeightPrice = 0;
        l.forEach(p => {
          var heightPrice = jQ(".boost-pfs-filter-products").find(`[data-id='${p}'] .product-card .price`).height();
          if (heightPrice >= maxHeightPrice) maxHeightPrice = heightPrice;
        })
        l.forEach(p => {
          jQ(".boost-pfs-filter-products").find(`[data-id='${p}'] .product-card .price`).height(maxHeightPrice + 2 );

        })
      })
    }
  
  	/* start-boost-custom */
  	Filter.prototype.setData = function(data, eventType, eventInfo) {
		this.isFetchedFilterData = false;
		this.isFetchedProductData = false;
		this.data = JSON.parse(JSON.stringify(data));
		this.fromCache = data.from_cache;
		this.error = data.error;

		// Remove functions from query params
		var cleanQueryParams = JSON.parse(JSON.stringify(Globals.queryParams));
		Globals.queryParams = cleanQueryParams;

		// Restore the active currency prices
		if (typeof Globals.activeCurrencyPrices !== 'undefined') {
			jQ.extend(Globals.queryParams, Globals.activeCurrencyPrices);
		}

		this.eventType = eventType ? eventType : data.event_type;
		this.clickedFilterOptionId = (eventInfo && eventInfo.filterOptionId && eventType != 'clear') ? eventInfo.filterOptionId : '';

		data = this.modifyData(data);

		if (data.filter && data.filter.options && Globals.imutableFilterTree.indexOf(this.eventType) == -1) {
			this.isFetchedFilterData = true;
			this.filterTrees.forEach((filterTree) => {
              	//console.log(data.filter);
				filterTree.setData(data.filter);
			});
		}
		
		if (data.products || data.collections || data.pages) {
			this.isFetchedProductData = true;
			this.filterResult.setData(data);
		}

		this.refresh();
		this.filterLoadingIcon.setShow(false);
	};
  
  	FilterTree.prototype.renderFull = function() {
		this.$element = jQ(this.compileTemplate());
		this.$filterOptionsContainerElement = this.$element.find(this.selector.filterOptionsWrapper);
      	//console.log(this.filterOptions);
      	this.filterOptions.forEach((filterOption) => {
			this.$filterOptionsContainerElement.append(filterOption.$element);
		})
	};
  
    FilterTree.prototype.afterRender = function() {
    	this.$filterOptionsContainerElement.remove('.boost-pfs-filter-header-custom').prepend("<div class='boost-pfs-filter-header-custom'><h3>Filter</h3></div>");
    };
  
  	FilterTree.prototype.modifyOptionsData = function(options) {
		var advancedRangeSliders = Settings.getSettingValue('general.advancedRangeSliders');
		options.forEach((optionData) => {

			// Check if option is advanced range slider
			if (Array.isArray(advancedRangeSliders) && advancedRangeSliders.includes(optionData.filterOptionId)
				&& optionData.selectType == FilterOptionEnum.SelectType.MULTIPLE) {
				optionData.displayType = FilterOptionEnum.DisplayType.RANGE;
			}

			// Back end returns filterType='multi_level_tag', with displayType='list' or 'box' or 'swatch'.
			// But front-end lib split components by displayType,
			// so we need to re-assign displayType='multi_level_tag' instead.
			if (optionData.filterType == FilterOptionEnum.FilterType.MULTI_LEVEL_TAG) {
				// Assign 'list' or 'box' or 'swatch' to displayTypeItem.
				switch (optionData.displayType) {
					case FilterOptionEnum.DisplayType.LIST:
						optionData.displayTypeItem = FilterOptionEnum.DisplayType.LIST;
						break;
					case FilterOptionEnum.DisplayType.BOX:
						optionData.displayTypeItem = FilterOptionEnum.DisplayType.BOX;
						break;
					case FilterOptionEnum.DisplayType.SWATCH:
						optionData.displayTypeItem = FilterOptionEnum.DisplayType.SWATCH;
						break;
					default:
						return;
				}

				// Assign displayType = 'multi_level_tag'
				optionData.displayType = FilterOptionEnum.DisplayType.MULTI_LEVEL_TAG;
			}

			// Disable filter option by vendor on vendor page, by product type on product type page
			if (Utils.isVendorPage() && optionData.filterType == FilterOptionEnum.FilterType.VENDOR) {
				optionData.status = FilterOptionEnum.Status.DISABLED;
			} else if (Utils.isTypePage() && optionData.filterType == FilterOptionEnum.FilterType.PRODUCT_TYPE) {
				optionData.status = FilterOptionEnum.Status.DISABLED;
			}

			// Disable filter option sub-category (use multi-level instead)
			//if (optionData.displayType == FilterOptionEnum.DisplayType.SUB_CATEGORY) {
			//	optionData.status = FilterOptionEnum.Status.DISABLED;
			//}
		})
	};
    
  	FilterTree.prototype.setData = function(data) {

		// When filering on the same collection, save the filter option we clicked on, so we don't rebuild it
		if (Settings.getSettingValue('general.filterTreeEnableRenderPartially') && this.collectionId == Globals.collectionId) {
			this.clickedFilterOption = this.filterOptions.get(this.parent.clickedFilterOptionId);
		} else {
			this.collectionId = Globals.collectionId;
			this.clickedFilterOption = null;
		}
		this.isRenderPartially = !!(this.$element && this.clickedFilterOption && this.clickedFilterOption.$element);

		// Modify/Prepare the option data
		this.modifyOptionsData(data.options);

		this.children = [];
		this.filterOptions = new Map();

		data.options.forEach((optionData) => {
          
			// Check if option is enabled
			if (optionData.status != FilterOptionEnum.Status.ACTIVE) {
				return;
			}

			// Check if optionData has empty values
			if ((Array.isArray(optionData.values) && optionData.values.length == 0)
				&& (Array.isArray(optionData.manualValues) && optionData.manualValues.length == 0)) {
				return;
			}

			// Check if option element is the one clicked on
			var filterOption = null;
			if (this.clickedFilterOption && optionData.filterOptionId == this.clickedFilterOption.filterOptionId) {
				filterOption = this.clickedFilterOption;
			}

			if (filterOption == null) {
				switch (optionData.displayType) {
					case FilterOptionEnum.DisplayType.LIST:
						filterOption = new FilterOptionList(this.filterTreeType);
						break;
					case FilterOptionEnum.DisplayType.BOX:
						filterOption = new FilterOptionBox(this.filterTreeType);
						break;
					case FilterOptionEnum.DisplayType.RANGE:
						filterOption = new FilterOptionRangeSlider(this.filterTreeType);
						break;
					case FilterOptionEnum.DisplayType.SWATCH:
						filterOption = new FilterOptionSwatch(this.filterTreeType);
						break;
					case FilterOptionEnum.DisplayType.RATING:
						filterOption = new FilterOptionRating(this.filterTreeType);
						break;
					case FilterOptionEnum.DisplayType.SUB_CATEGORY:
						filterOption = new FilterOptionSubCategory(this.filterTreeType);
						break;
					case FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS:
						filterOption = new FilterOptionMultiLevelCollections(this.filterTreeType);
						break;
					case FilterOptionEnum.DisplayType.MULTI_LEVEL_TAG:
						filterOption = new FilterOptionMultiLevelTag(this.filterTreeType);
						break;
					default:
						break;
				}
				if (!filterOption) {
					return;
				}
				filterOption.setData(optionData);
			}
			this.addComponent(filterOption);
			this.filterOptions.set(optionData.filterOptionId, filterOption);
		});

		if (Settings.getSettingValue('general.showRefineBy')) {
			this.refineBy = new FilterRefineBy(this.filterTreeType);
			this.addComponent(this.refineBy);
			this.refineBy.setData();
		}
		this.addComponent(this.clearAllButton);
		this.addComponent(this.applyAllButton);
	}
    
    function adjustProductHeightOther(data) {
      var item_per_row = 3;
      if(jQ(window).width() < 767) {
        item_per_row = 2;
      }

      var chunk = item_per_row;
      var rows = [];
      //Divide array into chuncks of products per row
      for (var i=0; i< data.length ; i+=chunk) {
        rows.push(data.slice(i,i+chunk));
      }
      rows.forEach(function(row){
        var maxHeightTitle = 0;
        var maxHeightJgm = 0;
        row.forEach(function(product){
          var heightTitle = jQ(Selector.products).find("[data-id='"+ product.id +"'].notHeighted .product-card__title").height();
          var heightJgm = jQ(Selector.products).find("[data-id='"+ product.id +"'].notHeighted .jdgm-widget").height();
          if (heightTitle > maxHeightTitle) maxHeightTitle = heightTitle;
          if (heightJgm > maxHeightJgm) maxHeightJgm = heightJgm;
        })
        row.forEach(function(product){

          jQ(Selector.products).find("[data-id='"+ product.id +"'].notHeighted .grid-view-item__title").css({
            height: maxHeightTitle,
          })

          jQ(Selector.products).find("[data-id='"+ product.id +"'].notHeighted .jdgm-widget").css({
            height: maxHeightJgm,
          })

          jQ(Selector.products).find("[data-id='"+ product.id +"'].notHeighted").removeClass("notHeighted")
        })
      })
    }
  
    /* #boost-101298: Customize OTP buttons */
    var renderOTP = BoostOTP.OTPButtons.render;
    BoostOTP.OTPButtons.render = function(product) {
      renderOTP.call(this, product);
      
      var changeButton = false;
      var buttonLabel = '';
      
      for (var tag of product.data.tags) {
        var ltag = tag.toLowerCase();
       
        if (ltag == 'not saleable') {
          buttonLabel = 'Notify Me';
          changeButton = true;
          break;
        } 


		if (ltag == 'pre-book now') {
			buttonLabel = 'Pre-book Now';
			changeButton = true;
			break;
		  } 
        
      
		   if (ltag == 'coming soon') {
          buttonLabel = 'Coming Soon';
          changeButton = true;
          break;
        }

        if (ltag == 'pre-order now') {
          buttonLabel = 'Pre Order';
          changeButton = true;
          break;
        }
      }
      
      var isNotify = product.data.tags.findIndex(tag => tag.toLowerCase() === 'not saleable') > -1;

      if (changeButton) {
        var $button = product.$element.find('.boost-pfs-addtocart-btn');
        if ($button.length > 0) {
          $button
          	.attr('aria-label', buttonLabel)
          	.attr('type', 'button')
          	.attr('onclick', "window.location='" + Utils.buildProductItemUrl(product.data) + "'")
            .removeAttr('disabled')
            .addClass('snehal');
          $button.find('.boost-pfs-addtocart-btn-text').html(buttonLabel);
        }
      }
      else
        {
          var $button = product.$element.find('.boost-pfs-addtocart-btn');
          $button.attr('type', 'button');
          $button.addClass("add_cart");
       
        }
    }
    
  	/* end-boost-custom */

    /* Start-Boost-204820 */
    BoostOTP.inject(this);
    AddToCart.prototype.compileTemplate = function() {
        var productUrl = Utils.buildProductItemUrl(this.parent.data);
        var clickAction = '';
        var label = '';
        var variantId = '';
        var buttonClass = '';
        var productData = this.parent.data;
        var productListData = this.parent.parent.data;
    
        var productIsFirst = false;
        if (Array.isArray(productListData)) {
            productIsFirst = productData.id == productListData[0].id;
        } else if (Array.isArray(productListData.products)) {
            productIsFirst = productData.id == productListData.products[0].id;
        }
    
        var icoCart = Settings.getSettingValue('general.icoCart');
    
        var icoCartLink = Settings.getSettingValue('general.icoCartLink');

        if (productData.tags.includes('WarrantyProduct')) {
            return '';
        } else {
            if (productData.available) {
                if (productData.variants.length == 1) {
                    // Buy now if have 1 variant
                    clickAction = Settings.getSettingValue('general.enableAjaxCart') ? '' : 'type="submit"';
                    variantId = productData.variants[0].id;
                    label = Labels.action_list.atcAvailableLabel;
                    buttonClass = Class.atcAvailable;
                    this.type = AddToCart.Type.ADD_TO_CART;
                    this.variantId = variantId;
                } else {
                    // Select options (link to product page) if have > 1 variant
                    clickAction = Settings.getSettingValue('general.enableAjaxCart') ?
                         'onclick="window.location.href=\'' + productUrl + '\'" type="button"' : '' 
                    label = Labels.action_list.atcSelectOptionsLabel;
                    buttonClass = Class.atcSelectOptions;
                    this.type = AddToCart.Type.SELECT_OPTIONS;
                }
            } else {
                clickAction = 'disabled type="button"';
                label = Labels.action_list.atcSoldOutLabel;
                buttonClass = Class.atcSoldOut;
                this.type = AddToCart.Type.SOLD_OUT;
            }
        
            return this.getTemplate()
                .replace(/{{class.atcForm}}/g, Class.atcForm)
                .replace(/{{label}}/g, label)
                .replace(/{{variantId}}/g, variantId)
                .replace(/{{clickAction}}/g, clickAction)
                .replace(/{{buttonClass}}/g, buttonClass)
                .replace(/{{productUrl}}/g, productUrl)
                .replace(/{{icoCart}}/g, productIsFirst ? icoCart : icoCartLink);
        }
    }
    /* End-Boost-204820 */
    /* Boost-219195 */
    BoostOTP.AjaxCart.prototype.onSucess = function(data, $addingLabel, $errorLabel, addToCartLabel = Labels.action_list.atcAvailableLabel) {
        this.changeButtonLabel($addingLabel, Labels.action_list.atcAddingToCartBtnLabel, Labels.action_list.atcAddedToCartBtnLabel);
        setTimeout(() => {
            this.changeButtonLabel($addingLabel, Labels.action_list.atcAddedToCartBtnLabel, addToCartLabel);
        }, 700);
        var isOpenCart = Settings.getSettingValue('general.showAjaxCartOnAdd');
        if (Settings.getSettingValue('general.ajaxCartStyle') === 'none') {
            isOpenCart = false;
            
        }
        // this.getCart(isOpenCart);
        // Custom code here
        setTimeout(() => {
            window.location = '/cart';  
        }, 500);
    }
    /* Boost-219195 */
})();